// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__bQS+u","active":"Chip_active__Zh-kQ"};